export interface Drama {
  id: string;
  title: string;
  poster: string;
  backdrop: string;
  types: string[];
  region: string;
  year: number;
  director: string;
  cast: string[];
  synopsis: string;
  hot: number;
  updatedAt: string;
  episodes: number;
  featured?: boolean;
}

export const dramas: Drama[] = [
  {
    id: "changan-que",
    title: "长安阙",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20of%20an%20ancient%20Chinese%20palace%20intrigue%20drama%2C%20lone%20figure%20in%20dark%20crimson%20robe%20standing%20before%20a%20vast%20imperial%20gate%2C%20warm%20deep%20red%20and%20dark%20gold%20color%20palette%2C%20dramatic%20rim%20lighting%2C%20textured%20dark%20background%2C%20elegant%20minimalist%20layout%20with%20negative%20space%2C%20high%20detail%20editorial%20cinematic%20art&width=600&height=900&seq=poster-changan-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20establishing%20shot%20of%20an%20ancient%20Chinese%20imperial%20palace%20city%20at%20dusk%2C%20layered%20red%20towers%20and%20golden%20lanterns%2C%20warm%20deep%20red%20and%20dark%20gold%20color%20palette%2C%20dramatic%20haze%20and%20volumetric%20light%2C%20moody%20cinematic%20atmosphere%2C%20high%20detail%20film%20still&width=1920&height=1080&seq=back-changan-01&orientation=landscape",
    types: ["古装", "权谋"],
    region: "中国大陆",
    year: 2024,
    director: "顾长风",
    cast: ["a-01", "a-04", "a-05"],
    synopsis:
      "盛唐末年，朝堂暗流涌动。一位出身寒门的年轻史官意外卷入皇权更迭的漩涡，他与掌印女官、边关将军结成同盟，在权力与良知的拉扯中，一步步揭开长安城深藏的旧案。全剧以考究的美术和群像叙事，还原一幅恢弘而苍凉的时代画卷。",
    hot: 98,
    updatedAt: "2024-10-12",
    episodes: 46,
    featured: true,
  },
  {
    id: "chengshi-fusheng",
    title: "都市浮生",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20of%20a%20modern%20metropolitan%20emotional%20drama%2C%20elegant%20woman%20gazing%20over%20a%20neon%20city%20skyline%20at%20night%2C%20warm%20deep%20red%20and%20dark%20gold%20color%20palette%2C%20dramatic%20rim%20lighting%2C%20textured%20dark%20background%2C%20elegant%20minimalist%20layout%20with%20negative%20space%2C%20high%20detail%20editorial%20cinematic%20art&width=600&height=900&seq=poster-chengshi-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20luxury%20modern%20city%20skyline%20at%20blue%20hour%20seen%20from%20a%20high%20glass%20office%2C%20warm%20amber%20window%20lights%2C%20deep%20red%20and%20dark%20gold%20color%20grading%2C%20cinematic%20haze%20and%20reflections%2C%20premium%20film%20still%2C%20high%20detail&width=1920&height=1080&seq=back-chengshi-02&orientation=landscape",
    types: ["都市", "情感"],
    region: "中国大陆",
    year: 2024,
    director: "林清和",
    cast: ["a-03", "a-06", "a-02"],
    synopsis:
      "三十二岁的职场精英在事业巅峰期遭遇公司重组，一夜之间回到起点。她重新结识了创业青年与老友，在同居屋檐下的日常摩擦中找回了生活的热气。剧集以细腻的笔触描摹都市人的孤独与自愈。",
    hot: 95,
    updatedAt: "2024-10-11",
    episodes: 40,
    featured: true,
  },
  {
    id: "miwu-zhuixiong",
    title: "迷雾追凶",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20of%20a%20crime%20suspense%20thriller%2C%20silhouette%20of%20a%20detective%20in%20a%20foggy%20alley%20with%20cold%20flashlights%2C%20warm%20deep%20red%20and%20dark%20gold%20color%20palette%2C%20dramatic%20rim%20lighting%2C%20textured%20dark%20background%2C%20elegant%20minimalist%20layout%20with%20negative%20space%2C%20high%20detail%20editorial%20cinematic%20art&width=600&height=900&seq=poster-miwu-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20rain%20soaked%20narrow%20city%20alley%20at%20night%20with%20fog%20and%20distant%20red%20neon%2C%20deep%20red%20and%20dark%20gold%20color%20grading%2C%20volumetric%20light%20beams%2C%20tense%20moody%20thriller%20film%20still%2C%20high%20detail&width=1920&height=1080&seq=back-miwu-03&orientation=landscape",
    types: ["悬疑", "犯罪"],
    region: "中国大陆",
    year: 2023,
    director: "周无咎",
    cast: ["a-02", "a-08", "a-07"],
    synopsis:
      "一桩尘封十二年的悬案因匿名举报信重新开卷。固执的老刑警与年轻的犯罪心理顾问组成临时搭档，随着调查深入，真相逐渐指向体制内部最不愿被触碰的角落。推理严密的双线叙事是本剧最大看点。",
    hot: 92,
    updatedAt: "2024-10-10",
    episodes: 32,
    featured: true,
  },
  {
    id: "shanhe-guren",
    title: "山河故人",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20of%20a%20historical%20epic%20drama%2C%20a%20scholar%20standing%20on%20a%20cliff%20overlooking%20mountains%20and%20rivers%20in%20mist%2C%20warm%20deep%20red%20and%20dark%20gold%20color%20palette%2C%20dramatic%20rim%20lighting%2C%20textured%20dark%20background%2C%20elegant%20minimalist%20layout%20with%20negative%20space%2C%20high%20detail%20editorial%20cinematic%20art&width=600&height=900&seq=poster-shanhe-04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20panorama%20of%20ancient%20Chinese%20mountains%20and%20rivers%20in%20morning%20mist%20with%20a%20lone%20traveler%20on%20a%20stone%20path%2C%20deep%20red%20and%20dark%20gold%20color%20grading%2C%20soft%20light%20rays%2C%20painterly%20historical%20epic%20film%20still%2C%20high%20detail&width=1920&height=1080&seq=back-shanhe-04&orientation=landscape",
    types: ["历史", "正剧"],
    region: "中国大陆",
    year: 2023,
    director: "谢长风",
    cast: ["a-04", "a-09"],
    synopsis:
      "跨越三十年的家族史诗。一位留洋归来的工程师选择回到贫瘠的故乡修桥铺路，他用半生时间见证了山河变迁与人心冷暖。剧集以沉稳的镜头语言，讲述个体命运与时代洪流的交织。",
    hot: 88,
    updatedAt: "2024-10-08",
    episodes: 38,
  },
  {
    id: "congcong-nanian",
    title: "匆匆那年夏天",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20of%20a%20youth%20campus%20drama%2C%20two%20students%20on%20a%20school%20rooftop%20under%20warm%20afternoon%20sunlight%2C%20warm%20deep%20red%20and%20dark%20gold%20color%20palette%2C%20dramatic%20rim%20lighting%2C%20textured%20dark%20background%2C%20elegant%20minimalist%20layout%20with%20negative%20space%2C%20high%20detail%20editorial%20cinematic%20art&width=600&height=900&seq=poster-congcong-05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20sunlit%20high%20school%20corridor%20in%20late%20summer%20with%20fluttering%20curtains%20and%20dappled%20light%2C%20warm%20deep%20red%20and%20dark%20gold%20color%20grading%2C%20nostalgic%20soft%20film%20still%2C%20high%20detail&width=1920&height=1080&seq=back-congcong-05&orientation=landscape",
    types: ["青春", "校园"],
    region: "中国大陆",
    year: 2022,
    director: "何一诺",
    cast: ["a-05", "a-08"],
    synopsis:
      "毕业十年后的一场同学聚会，让五位老友重新翻开那本写满秘密的同学录。借着夏天的蝉鸣与操场上的汗水，剧集追问一个朴素的问题：我们究竟把最好的自己弄丢在哪一年。",
    hot: 76,
    updatedAt: "2024-10-06",
    episodes: 24,
  },
  {
    id: "xinghai-yuanzheng",
    title: "星海远征",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20of%20a%20science%20fiction%20space%20drama%2C%20a%20lone%20astronaut%20facing%20a%20vast%20deep%20red%20nebula%20and%20distant%20planet%2C%20warm%20deep%20red%20and%20dark%20gold%20color%20palette%2C%20dramatic%20rim%20lighting%2C%20textured%20dark%20background%2C%20elegant%20minimalist%20layout%20with%20negative%20space%2C%20high%20detail%20editorial%20cinematic%20art&width=600&height=900&seq=poster-xinghai-06&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20massive%20spaceship%20bridge%20with%20a%20view%20of%20a%20deep%20red%20nebula%20and%20ringed%20planet%2C%20warm%20deep%20red%20and%20dark%20gold%20color%20grading%2C%20volumetric%20light%2C%20epic%20science%20fiction%20film%20still%2C%20high%20detail&width=1920&height=1080&seq=back-xinghai-06&orientation=landscape",
    types: ["科幻", "冒险"],
    region: "中国大陆",
    year: 2024,
    director: "陈星河",
    cast: ["a-06", "a-10"],
    synopsis:
      "人类第一艘跨星系远征舰在航行第十三年的深空失去联络。留守的通讯官独自值守地面站，用延迟数十光年的讯号维系最后的联系。剧集在硬核设定的外壳下，讲述关于孤独与等待的故事。",
    hot: 84,
    updatedAt: "2024-10-09",
    episodes: 28,
    featured: true,
  },
  {
    id: "jiayou-xishi",
    title: "家有喜事",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20of%20a%20warm%20family%20comedy%20drama%2C%20a%20cheerful%20multi%20generation%20family%20gathered%20around%20a%20dinner%20table%2C%20warm%20deep%20red%20and%20dark%20gold%20color%20palette%2C%20dramatic%20rim%20lighting%2C%20textured%20dark%20background%2C%20elegant%20minimalist%20layout%20with%20negative%20space%2C%20high%20detail%20editorial%20cinematic%20art&width=600&height=900&seq=poster-jiayou-07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20cozy%20warm%20lit%20Chinese%20family%20dining%20room%20with%20steaming%20dishes%20and%20festive%20decorations%2C%20deep%20red%20and%20dark%20gold%20color%20grading%2C%20soft%20intimate%20lighting%2C%20heartwarming%20film%20still%2C%20high%20detail&width=1920&height=1080&seq=back-jiayou-07&orientation=landscape",
    types: ["喜剧", "家庭"],
    region: "中国大陆",
    year: 2022,
    director: "赵欢乐",
    cast: ["a-07", "a-09"],
    synopsis:
      "老父亲突然宣布要把祖宅改造成民宿，一大家子的平静生活被彻底打乱。三代人在鸡飞狗跳的日常里重新学习沟通与理解。轻喜剧节奏搭配扎实的人物塑造，笑中带暖。",
    hot: 70,
    updatedAt: "2024-10-03",
    episodes: 30,
  },
  {
    id: "baise-chengbao",
    title: "白色城堡",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20of%20a%20medical%20workplace%20drama%2C%20a%20determined%20young%20doctor%20in%20a%20bright%20hospital%20corridor%20at%20dawn%2C%20warm%20deep%20red%20and%20dark%20gold%20color%20palette%2C%20dramatic%20rim%20lighting%2C%20textured%20dark%20background%2C%20elegant%20minimalist%20layout%20with%20negative%20space%2C%20high%20detail%20editorial%20cinematic%20art&width=600&height=900&seq=poster-baise-08&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20modern%20hospital%20corridor%20at%20dawn%20with%20soft%20window%20light%20and%20medical%20staff%20silhouettes%2C%20deep%20red%20and%20dark%20gold%20color%20grading%2C%20clean%20clinical%20atmosphere%20with%20warm%20accents%2C%20drama%20film%20still%2C%20high%20detail&width=1920&height=1080&seq=back-baise-08&orientation=landscape",
    types: ["医疗", "行业"],
    region: "中国大陆",
    year: 2023,
    director: "沈知远",
    cast: ["a-01", "a-08"],
    synopsis:
      "急诊科的天才住院医与固执的主任医师针锋相对，却在一场突如其来的公共卫生事件中成为最默契的搭档。剧集聚焦医患关系与年轻医生的成长，真实而克制。",
    hot: 81,
    updatedAt: "2024-10-05",
    episodes: 36,
  },
  {
    id: "jianghu-yeyu",
    title: "江湖夜雨",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20of%20a%20wuxia%20martial%20arts%20drama%2C%20a%20swordsman%20standing%20in%20rain%20with%20a%20glowing%20blade%20and%20bamboo%20forest%2C%20warm%20deep%20red%20and%20dark%20gold%20color%20palette%2C%20dramatic%20rim%20lighting%2C%20textured%20dark%20background%2C%20elegant%20minimalist%20layout%20with%20negative%20space%2C%20high%20detail%20editorial%20cinematic%20art&width=600&height=900&seq=poster-jianghu-09&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20misty%20bamboo%20forest%20at%20night%20with%20falling%20rain%20and%20a%20distant%20lantern%20glow%2C%20deep%20red%20and%20dark%20gold%20color%20grading%2C%20volumetric%20mist%2C%20atmospheric%20wuxia%20film%20still%2C%20high%20detail&width=1920&height=1080&seq=back-jianghu-09&orientation=landscape",
    types: ["武侠", "古装"],
    region: "中国大陆",
    year: 2021,
    director: "古越",
    cast: ["a-10", "a-05"],
    synopsis:
      "退隐多年的剑客因一封故人遗书重返江湖，却发现昔日的恩怨早已被权势改写。刀光剑影之外，剧集更想讲述一个人如何与自己的过去和解。",
    hot: 74,
    updatedAt: "2024-09-28",
    episodes: 42,
  },
  {
    id: "shanghai-chenfu",
    title: "商海沉浮",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20of%20a%20corporate%20business%20war%20drama%2C%20a%20confident%20executive%20silhouette%20against%20a%20tower%20of%20glass%20office%20windows%2C%20warm%20deep%20red%20and%20dark%20gold%20color%20palette%2C%20dramatic%20rim%20lighting%2C%20textured%20dark%20background%2C%20elegant%20minimalist%20layout%20with%20negative%20space%2C%20high%20detail%20editorial%20cinematic%20art&width=600&height=900&seq=poster-shanghai-10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20high%20rise%20financial%20district%20boardroom%20at%20night%20with%20city%20lights%20below%2C%20deep%20red%20and%20dark%20gold%20color%20grading%2C%20reflective%20marble%20surfaces%2C%20tense%20corporate%20drama%20film%20still%2C%20high%20detail&width=1920&height=1080&seq=back-shanghai-10&orientation=landscape",
    types: ["商战", "都市"],
    region: "中国大陆",
    year: 2024,
    director: "秦浩然",
    cast: ["a-04", "a-03"],
    synopsis:
      "一家老牌企业的继承权之争，把两个昔日同窗推向对立面。资本、道义与友情在谈判桌上被反复称量。剧集以扎实的行业细节，呈现商场背后的智力博弈。",
    hot: 86,
    updatedAt: "2024-10-10",
    episodes: 44,
    featured: true,
  },
  {
    id: "shiguang-youju",
    title: "时光邮局",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20of%20a%20fantasy%20romance%20drama%2C%20a%20vintage%20post%20office%20with%20glowing%20floating%20letters%20and%20warm%20light%2C%20warm%20deep%20red%20and%20dark%20gold%20color%20palette%2C%20dramatic%20rim%20lighting%2C%20textured%20dark%20background%2C%20elegant%20minimalist%20layout%20with%20negative%20space%2C%20high%20detail%20editorial%20cinematic%20art&width=600&height=900&seq=poster-shiguang-11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20nostalgic%20vintage%20post%20office%20interior%20at%20dusk%20with%20stacks%20of%20old%20letters%20and%20glowing%20lamp%2C%20deep%20red%20and%20dark%20gold%20color%20grading%2C%20soft%20dreamy%20light%2C%20romantic%20fantasy%20film%20still%2C%20high%20detail&width=1920&height=1080&seq=back-shiguang-11&orientation=landscape",
    types: ["奇幻", "爱情"],
    region: "韩国",
    year: 2023,
    director: "金泰勋",
    cast: ["a-05", "a-02"],
    synopsis:
      "老城区的邮局里藏着一个秘密：投进红色邮筒的信，会被送到最想送达的那个人手中，无论他们相隔多远。一段跨越时间的通信，让两个陌生人的人生悄然交错。",
    hot: 79,
    updatedAt: "2024-10-04",
    episodes: 16,
  },
  {
    id: "wuming-zhibei",
    title: "无名之辈",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20of%20a%20gritty%20social%20realist%20drama%2C%20a%20weathered%20worker%20walking%20through%20an%20old%20town%20alley%20at%20sunset%2C%20warm%20deep%20red%20and%20dark%20gold%20color%20palette%2C%20dramatic%20rim%20lighting%2C%20textured%20dark%20background%2C%20elegant%20minimalist%20layout%20with%20negative%20space%2C%20high%20detail%20editorial%20cinematic%20art&width=600&height=900&seq=poster-wuming-12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20an%20old%20Chinese%20town%20street%20at%20sunset%20with%20market%20stalls%20and%20warm%20dust%20light%2C%20deep%20red%20and%20dark%20gold%20color%20grading%2C%20nostalgic%20gritty%20realist%20film%20still%2C%20high%20detail&width=1920&height=1080&seq=back-wuming-12&orientation=landscape",
    types: ["现实", "剧情"],
    region: "中国大陆",
    year: 2022,
    director: "王守拙",
    cast: ["a-06", "a-09"],
    synopsis:
      "快递员、修车师傅、夜市摊主，一群在城市边缘努力活着的小人物，因为一场意外被拧在了一起。剧集用平视的镜头，写尽平凡人的体面与倔强。",
    hot: 68,
    updatedAt: "2024-09-30",
    episodes: 26,
  },
  {
    id: "dieying-chongchong",
    title: "谍影重重",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20of%20a%20spy%20thriller%20drama%2C%20a%20stern%20agent%20in%20a%20trench%20coat%20under%20a%20rainy%20street%20lamp%2C%20warm%20deep%20red%20and%20dark%20gold%20color%20palette%2C%20dramatic%20rim%20lighting%2C%20textured%20dark%20background%2C%20elegant%20minimalist%20layout%20with%20negative%20space%2C%20high%20detail%20editorial%20cinematic%20art&width=600&height=900&seq=poster-dieying-13&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20an%20old%20city%20street%20at%20night%20in%20the%201930s%20with%20rain%20gaslights%20and%20vintage%20cars%2C%20deep%20red%20and%20dark%20gold%20color%20grading%2C%20tense%20noir%20atmosphere%2C%20espionage%20film%20still%2C%20high%20detail&width=1920&height=1080&seq=back-dieying-13&orientation=landscape",
    types: ["谍战", "年代"],
    region: "中国大陆",
    year: 2021,
    director: "韩铁衣",
    cast: ["a-02", "a-10"],
    synopsis:
      "情报战线上，一个代号“惊蛰”的潜伏者必须同时骗过敌人与自己的同僚。每一次传递都可能是最后一次。剧集以紧绷的节奏，呈现信仰与牺牲的重量。",
    hot: 72,
    updatedAt: "2024-09-25",
    episodes: 40,
  },
  {
    id: "yanhuo-renjian",
    title: "烟火人间",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20of%20a%20nostalgic%20period%20drama%2C%20a%20family%20in%20front%20of%20an%20old%20brick%20courtyard%20house%20with%20warm%20lanterns%2C%20warm%20deep%20red%20and%20dark%20gold%20color%20palette%2C%20dramatic%20rim%20lighting%2C%20textured%20dark%20background%2C%20elegant%20minimalist%20layout%20with%20negative%20space%2C%20high%20detail%20editorial%20cinematic%20art&width=600&height=900&seq=poster-yanhuo-14&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20warm%20old%20Chinese%20neighborhood%20at%20evening%20with%20smoke%20from%20chimneys%20and%20hanging%20red%20lanterns%2C%20deep%20red%20and%20dark%20gold%20color%20grading%2C%20nostalgic%20soft%20light%2C%20period%20drama%20film%20still%2C%20high%20detail&width=1920&height=1080&seq=back-yanhuo-14&orientation=landscape",
    types: ["年代", "家庭"],
    region: "中国大陆",
    year: 2022,
    director: "李怀旧",
    cast: ["a-07", "a-03"],
    synopsis:
      "从上世纪八十年代讲起，一条胡同里几户人家的悲欢离合。剧集用大量生活细节，复刻一个时代的烟火气，让人想起自家楼下那盏总也关不掉的灯。",
    hot: 66,
    updatedAt: "2024-09-22",
    episodes: 34,
  },
  {
    id: "zhuguang-zhe",
    title: "逐光者",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20of%20an%20inspirational%20sports%20drama%2C%20a%20young%20athlete%20sprinting%20on%20a%20track%20at%20golden%20hour%20with%20dust%20light%2C%20warm%20deep%20red%20and%20dark%20gold%20color%20palette%2C%20dramatic%20rim%20lighting%2C%20textured%20dark%20background%2C%20elegant%20minimalist%20layout%20with%20negative%20space%2C%20high%20detail%20editorial%20cinematic%20art&width=600&height=900&seq=poster-zhuguang-15&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20an%20empty%20running%20track%20at%20golden%20hour%20with%20long%20shadows%20and%20dust%20in%20the%20air%2C%20deep%20red%20and%20dark%20gold%20color%20grading%2C%20uplifting%20warm%20lighting%2C%20inspirational%20film%20still%2C%20high%20detail&width=1920&height=1080&seq=back-zhuguang-15&orientation=landscape",
    types: ["励志", "青春"],
    region: "中国香港",
    year: 2024,
    director: "麦子豪",
    cast: ["a-08", "a-01"],
    synopsis:
      "一名被伤病判了“死刑”的短跑运动员，在小城教练的坚持下重新站上起跑线。剧集没有奇迹式逆袭，只有一次次摔倒后重新站起来的过程，真实而滚烫。",
    hot: 83,
    updatedAt: "2024-10-07",
    episodes: 30,
  },
  {
    id: "shenhai-huixiang",
    title: "深海回响",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20of%20a%20mystery%20drama%20set%20on%20a%20remote%20island%2C%20a%20lighthouse%20in%20storm%20with%20crashing%20waves%20and%20cold%20light%2C%20warm%20deep%20red%20and%20dark%20gold%20color%20palette%2C%20dramatic%20rim%20lighting%2C%20textured%20dark%20background%2C%20elegant%20minimalist%20layout%20with%20negative%20space%2C%20high%20detail%20editorial%20cinematic%20art&width=600&height=900&seq=poster-shenhai-16&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20lonely%20lighthouse%20on%20a%20rocky%20island%20during%20a%20storm%20with%20dark%20waves%2C%20deep%20red%20and%20dark%20gold%20color%20grading%2C%20moody%20atmospheric%20mystery%20film%20still%2C%20high%20detail&width=1920&height=1080&seq=back-shenhai-16&orientation=landscape",
    types: ["悬疑", "惊悚"],
    region: "日本",
    year: 2023,
    director: "山崎健",
    cast: ["a-09", "a-06"],
    synopsis:
      "一座只有十二名居民的小岛迎来了新的气象观测员。他很快发现，岛上的每个人都在隐瞒同一件事——十年前那场海难，从来就没有过去。氛围压抑而沉浸。",
    hot: 77,
    updatedAt: "2024-10-02",
    episodes: 12,
  },
];

export const dramaTypes = [
  "都市",
  "古装",
  "悬疑",
  "历史",
  "青春",
  "科幻",
  "喜剧",
  "武侠",
  "商战",
  "谍战",
  "爱情",
  "年代",
  "励志",
  "医疗",
];

export const dramaRegions = ["中国大陆", "中国香港", "韩国", "日本"];

export const dramaYears = [2024, 2023, 2022, 2021];

export function getDramaById(id: string): Drama | undefined {
  return dramas.find((d) => d.id === id);
}